import AddIcon from "@mui/icons-material/Add";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Box, Button, Chip, Menu } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";
import { Detector } from "types/detectors";

import { FilterChip } from "./FilterChip";
import { FilterParams } from "./FiltersData";
import { FilterChanges, GridFilters } from "./GridFilters";


export interface FilterPosichecksProps {
  detector?: Detector;
  filterState: Record<string, any>;
  isDisabled: boolean;
  onFilterChange: (filterValues: FilterChanges[]) => void;
  filterableElements: FilterParams[];
}

export function FilterPosichecks(props: FilterPosichecksProps) {
  const { detector, filterState, isDisabled, onFilterChange, filterableElements } = props;

  // Menu Filters
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);

  const handleClickOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickRemoveFilter = (columnField: string | undefined) => {
    if (!columnField) {
      onFilterChange([]);
      return;
    }
    const removeItem = filterState.filterModel.items.filter((item: any) => item.columnField !== columnField);
    onFilterChange(removeItem);
  };

  return (
    <Box id="filter-posichecks" className="flex h-[50px] justify-between items-center">
      <Box className="flex items-baseline gap-4">
        <Typography variant="subtitle" className="ml-2">
          Filters:
        </Typography>

        <Box>
          <Button
            className={`${isDisabled ? "bg-slate-800" : "bg-slate-600"} rounded-2xl px-1`}
            disabled={isDisabled}
            onClick={handleClickOpen}
          >
            <AddIcon className="text-white" sx={{ height: "20px", width: "20px" }} />
          </Button>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            PaperProps={{
              className: "w-auto sm:min-w-[600px] max-h-[400px]",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <GridFilters
              detector={detector}
              filterableElements={filterableElements}
              isEdit={false}
              filterState={filterState}
              onFilterChange={onFilterChange}
              handleClose={handleClose}
            />
          </Menu>
        </Box>

        <Box className="flex items-center gap-4 flex-wrap">
          {filterState.filterModel.items && filterState.filterModel.items.length > 0 && (
            <Chip
              className="bg-slate-600 text-white"
              label="CLEAR ALL"
              onClick={() => handleClickRemoveFilter(undefined)}
              onDelete={() => handleClickRemoveFilter(undefined)}
              deleteIcon={<HighlightOffIcon className="text-white" />}
            />
          )}

          {filterState.filterModel.items &&
            filterState.filterModel.items.map((item: FilterChanges) => (
              <FilterChip
                key={item.columnField}
                detector={detector}
                columnField={item.columnField}
                filterOperator={item.operatorValue}
                filterValue={typeof item.value === "string" ? [item.value] : item.value}
                filterState={filterState}
                handleClickRemoveFilter={() => handleClickRemoveFilter(item.columnField)}
                onFilterChange={onFilterChange}
                filterableElements={filterableElements}
              />
            ))}
        </Box>
      </Box>
    </Box>
  );
}
